module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "radioSelect"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": _vm.label,
      "errorText": _vm.errorInfo
    },
    model: {
      value: (_vm.select),
      callback: function($$v) {
        _vm.select = $$v
      },
      expression: "select"
    }
  }, _vm._l((_vm.optionVal), function(op, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "value": op.id,
        "title": op.text
      },
      on: {
        "click": function($event) {
          _vm.sendData(op.id)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b7d299a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/radios.vue
// module id = 945
// module chunks = 2